/**
 * Status → badge tone.
 *
 * One mapping for the whole panel, so "confirmed" is the same green
 * everywhere and an unknown status degrades to neutral rather than crashing.
 */

const TONES = {
  // Shared
  active: 'success',
  verified: 'success',
  paid: 'success',
  succeeded: 'success',
  resolved: 'success',
  closed: 'success',
  completed: 'neutral',
  confirmed: 'success',
  checked_in: 'success',
  ready: 'success',

  pending: 'warning',
  pending_verification: 'warning',
  payment_pending: 'warning',
  in_review: 'warning',
  in_progress: 'warning',
  processing: 'warning',
  partially_paid: 'warning',
  past_due: 'warning',
  requires_payment: 'warning',
  scheduled: 'warning',
  open: 'warning',
  negotiating: 'warning',
  agreement: 'warning',

  suspended: 'danger',
  rejected: 'danger',
  failed: 'danger',
  cancelled: 'danger',
  disputed: 'danger',
  refunded: 'danger',
  no_show: 'danger',

  draft: 'neutral',
  paused: 'neutral',
  archived: 'neutral',
  expired: 'neutral',
  unverified: 'neutral',
  deactivated: 'neutral',
  dismissed: 'neutral',
  trialing: 'info',
  rented: 'info',
  new: 'info',
  viewed: 'info',
  contacted: 'info',
};

export function toneFor(status) {
  return TONES[status] || 'neutral';
}

const SEVERITY_TONES = {
  critical: 'danger',
  high: 'danger',
  warning: 'warning',
  medium: 'warning',
  notice: 'info',
  low: 'neutral',
  info: 'neutral',
};

export function severityTone(severity) {
  return SEVERITY_TONES[severity] || 'neutral';
}
